/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';
import { hearAboutGetResponseSchema } from './hearAboutGetResponseSchema.ts';

/**
 * @description 200 response
 */
export const getHearAbout200Schema = z.lazy(() => hearAboutGetResponseSchema);

/**
 * @description 505 response
 */
export const getHearAbout505Schema = z.any();

export const getHearAboutQueryResponseSchema = z.lazy(() => getHearAbout200Schema);
